/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** NotificationType */
export enum NotificationType {
  Push = 'push',
  DeleteShiftConflict = 'delete_shift_conflict',
  UpdateShiftConflict = 'update_shift_conflict',
  VisitCompleted = 'visit_completed',
  VisitUpdated = 'visit_updated',
  VisitDeleteBatchCompleted = 'visit_delete_batch_completed',
  VisitBillingSyncBatchCompleted = 'visit_billing_sync_batch_completed',
  VisitCompleteBatchCompleted = 'visit_complete_batch_completed',
  VisitRejected = 'visit_rejected',
  VisitAssignmentRemoved = 'visit_assignment_removed',
  VisitAssignmentAdded = 'visit_assignment_added',
  VisitAssignmentBatchAdded = 'visit_assignment_batch_added',
  VisitScheduleUpdated = 'visit_schedule_updated',
  VisitRescheduled = 'visit_rescheduled',
  VisitCheckInReminder = 'visit_check_in_reminder',
  VisitCheckedIn = 'visit_checked_in',
  AttachmentAdded = 'attachment_added',
  AttachmentRemoved = 'attachment_removed',
  ShiftUpdated = 'shift_updated',
  ShiftDeleted = 'shift_deleted',
  DataExportCompleted = 'data_export_completed',
  DataExportFailed = 'data_export_failed',
  PosPaymentReminder = 'pos_payment_reminder',
  CaregiverCashDepositRecorded = 'caregiver_cash_deposit_recorded',
  NoteAdded = 'note_added',
  DoctorInstructionSent = 'doctor_instruction_sent',
  DoctorInstructionDecided = 'doctor_instruction_decided',
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** MarkSelectedReadRequest */
export interface MarkSelectedReadRequest {
  /**
   * Notificationids
   * Notification IDs to mark as read
   * @minItems 1
   */
  notificationIds: number[];
}

/** MarkSelectedReadResponse */
export interface MarkSelectedReadResponse {
  /**
   * Userid
   * The user ID
   */
  userId: number;
  /**
   * Updatedcount
   * Number of notifications updated
   */
  updatedCount: number;
  /**
   * Updatedids
   * IDs that were marked as read
   */
  updatedIds?: number[];
  /**
   * Skippedids
   * IDs that were not updated (already read, not found, or not owned by user)
   */
  skippedIds?: number[];
}

/** Notification */
export interface Notification {
  /** Userid */
  userId: number;
  /** Title */
  title: string;
  /** Message */
  message: string;
  type: NotificationType;
  /**
   * Isread
   * @default false
   */
  isRead?: boolean;
  /** Sentat */
  sentAt?: string | null;
  /** Readat */
  readAt?: string | null;
  /** Targeturl */
  targetUrl?: string | null;
  /**
   * Metadata
   * Metadata for push notifications
   */
  metadata?:
    | (
        | NotificationActionVisitMetadata
        | NotificationVisitAssignmentBatchMetadata
        | NotificationScheduleUpdatedMetadata
        | NotificationScheduleChangeMetadata
        | NotificationActionCarergiverShiftMetadata
        | NotificationActionDataExportMetadata
        | NotificationNoteMetadata
        | NotificationDoctorInstructionMetadata
        | NotificationVisitBatchDeleteMetadata
        | NotificationVisitBillingSyncBatchMetadata
        | NotificationVisitCompleteBatchMetadata
      )[]
    | null;
  /**
   * Actionat
   * Timestamp the caregiver clicked approve/reject
   */
  actionAt?: string | null;
  /**
   * Actionvalue
   * Decision value for actionable notification
   */
  actionValue?: 'accept' | 'reject' | null;
  /** Notificationid */
  notificationId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
}

/** NotificationActionCarergiverShiftMetadata */
export interface NotificationActionCarergiverShiftMetadata {
  /** Caregivershiftid */
  caregiverShiftId: number;
  /** Caregiverid */
  caregiverId: number;
  /**
   * Periodfrom
   * @format date-time
   */
  periodFrom: string;
  /**
   * Periodto
   * @format date-time
   */
  periodTo: string;
  /** Notes */
  notes?: string | null;
}

/** NotificationActionDataExportMetadata */
export interface NotificationActionDataExportMetadata {
  /** Filepath */
  filePath?: string | null;
  /**
   * Success
   * @default true
   */
  success?: boolean;
  /** Generatedat */
  generatedAt?: string | null;
}

/** NotificationActionRequest */
export interface NotificationActionRequest {
  /** Actionvalue */
  actionValue: 'accept' | 'reject';
  /** Visitid */
  visitId: number;
  /** Caregiverid */
  caregiverId: number;
  /** Caregivername */
  caregiverName: string;
  /**
   * Reason
   * Optional caregiver rejection reason (reject only)
   */
  reason?: string | null;
  /** Metadata for push notifications */
  data?: NotificationActionVisitMetadata | null;
}

/** NotificationActionResponse */
export interface NotificationActionResponse {
  /** Notificationid */
  notificationId: number;
  /** Action */
  action: 'accept' | 'reject';
  /** Visitid */
  visitId: number;
  /**
   * Actionat
   * @format date-time
   */
  actionAt: string;
  /** Adminsnotified */
  adminsNotified: number;
}

/** NotificationActionVisitMetadata */
export interface NotificationActionVisitMetadata {
  /** Address */
  address: string;
  /** Clientfirstname */
  clientFirstName: string;
  /** Clientlastname */
  clientLastName: string;
  /** Caregivernames */
  caregiverNames: string[];
  /** Visitstarttime */
  visitStartTime: string;
  /** Visitendtime */
  visitEndTime: string;
  /** Clientid */
  clientId: number;
  /** Visitid */
  visitId: number;
  /** Caregiverids */
  caregiverIds: number[];
  /** Reason */
  reason?: string | null;
}

/** NotificationCaregiverShiftMinifiedMetadata */
export interface NotificationCaregiverShiftMinifiedMetadata {
  /**
   * Periodfrom
   * @format date-time
   */
  periodFrom: string;
  /**
   * Periodto
   * @format date-time
   */
  periodTo: string;
}

/**
 * NotificationDoctorInstructionMetadata
 * What a doctor-instruction notification is about, and enough of it to read.
 *
 * The three ids are required, unlike the note shape: both senders resolve them
 * from the instruction row and the visit it hangs off, and an instruction
 * always has a visit - there is no client-level variant.
 *
 * Everything below them is optional and denormalised, because the dashboard
 * modal has no visit metadata to fall back on: its cards read
 * NotificationActionVisitMetadata, which an instruction never carries, so
 * without these fields the modal renders a heading, a link and two dividers
 * with nothing between them. Optional rather than required so every row
 * written before they shipped still validates - the modal guards each card.
 *
 * `instruction_id` is also the discriminator, and now load-bearing twice over:
 * `visit_start_time` makes the FULL discriminator's visit branch
 * (`visitid` AND `visitstarttime`) true for this shape, so the `instructionid`
 * test must keep running ahead of it in both unions.
 */
export interface NotificationDoctorInstructionMetadata {
  /** Instructionid */
  instructionId: number;
  /** Visitid */
  visitId: number;
  /** Clientid */
  clientId: number;
  /** Instructiontitle */
  instructionTitle?: string | null;
  /** Priority */
  priority?: string | null;
  /** Details */
  details?: string | null;
  /** Status */
  status?: string | null;
  /** Decisionnote */
  decisionNote?: string | null;
  /** Decidedbyname */
  decidedByName?: string | null;
  /** Clientname */
  clientName?: string | null;
  /** Visitstarttime */
  visitStartTime?: string | null;
  /** Visitendtime */
  visitEndTime?: string | null;
  /** Doctorname */
  doctorName?: string | null;
}

/** NotificationGetAllMinifiedPaginationResponse */
export interface NotificationGetAllMinifiedPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: NotificationMinified[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
  /** Totalunread */
  totalUnread: number;
}

/** NotificationGetAllPaginationResponse */
export interface NotificationGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: Notification[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
  /** Totalunread */
  totalUnread: number;
}

/** NotificationMinified */
export interface NotificationMinified {
  /** Notificationid */
  notificationId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Userid */
  userId: number;
  /** Title */
  title: string;
  /** Message */
  message: string;
  /**
   * Isread
   * @default false
   */
  isRead?: boolean;
  /**
   * Actionvalue
   * Decision value for actionable notification
   */
  actionValue?: 'accept' | 'reject' | null;
  /**
   * Metadata
   * Minified metadata containing caregiver and visit info
   */
  metadata?:
    | (
        | NotificationVisitMinifiedMetadata
        | NotificationVisitAssignmentBatchMetadata
        | NotificationScheduleUpdatedMetadata
        | NotificationScheduleChangeMetadata
        | NotificationCaregiverShiftMinifiedMetadata
        | NotificationActionDataExportMetadata
        | NotificationNoteMetadata
        | NotificationDoctorInstructionMetadata
        | NotificationVisitBatchDeleteMetadata
        | NotificationVisitBillingSyncBatchMetadata
        | NotificationVisitCompleteBatchMetadata
      )[]
    | null;
}

/**
 * NotificationNoteMetadata
 * Which patient a note notification is about, and which note it was.
 *
 * ``client_id`` is the actionable field: every reader of this notification can
 * open that patient. ``visit_id`` is present only when the note was filed on a
 * visit - a client-level note has none, and the visit-creation push is grouped
 * per client and covers several visits, so it sends none either.
 */
export interface NotificationNoteMetadata {
  /** Noteid */
  noteId?: number | null;
  /** Clientid */
  clientId: number;
  /** Visitid */
  visitId?: number | null;
}

/**
 * NotificationScheduleChangeMetadata
 * ONE changed visit inside a planning-session summary.
 *
 * A summary's metadata is ``[summary, *changes]``: the aggregate first, then one
 * of these per visit. The detail has to travel in the notification because the
 * recipient cannot fetch it - a ``removed`` visit is one they are no longer
 * assigned to, so RLS returns them nothing. Discriminated on ``change_kind``,
 * which is checked BEFORE the broad ``visitid``/``visitstarttime`` branch that
 * would otherwise route this to the single-visit shape.
 */
export interface NotificationScheduleChangeMetadata {
  /** Visitid */
  visitId: number;
  /** Changekind */
  changeKind: 'added' | 'removed' | 'retimed';
  /** Clientid */
  clientId?: number | null;
  /** Clientfirstname */
  clientFirstName?: string | null;
  /** Clientlastname */
  clientLastName?: string | null;
  /** Visitstarttime */
  visitStartTime: string;
  /** Visitendtime */
  visitEndTime?: string | null;
  /** Address */
  address?: string | null;
}

/**
 * NotificationScheduleUpdatedMetadata
 * One planning session's net change for one recipient.
 *
 * ``summary_kind`` selects the template and decides whether the mobile screen
 * offers a per-row Decline: a ``caregiver`` summary has rows to act on, an
 * ``office`` one is informational. There is no Accept - the app has never had
 * one, and silence is assent.
 *
 * Carries ``visit_ids`` (plural) and deliberately NO ``visit_id``: a summary
 * spans many visits across many clients, so there is no single visit for a
 * deep-link to open - which is also what keeps it apart from
 * NotificationActionVisitMetadata in the discriminators.
 */
export interface NotificationScheduleUpdatedMetadata {
  /** Summarykind */
  summaryKind: 'caregiver' | 'office';
  /** Planningsessionid */
  planningSessionId: number;
  /** Changecount */
  changeCount: number;
  /** Addedcount */
  addedCount: number;
  /** Removedcount */
  removedCount: number;
  /** Retimedcount */
  retimedCount: number;
  /** Firstchangedate */
  firstChangeDate: string;
  /** Lastchangedate */
  lastChangeDate: string;
  /** Visitids */
  visitIds: number[];
  /** Caregiverids */
  caregiverIds: number[];
  /** Caregivernames */
  caregiverNames: string[];
}

/** NotificationSendRequest */
export interface NotificationSendRequest {
  /**
   * Title
   * Notification title
   */
  title: string;
  /**
   * Body
   * Notification body
   */
  body: string;
  /**
   * Type of notification, e.g., 'push'
   * @default "push"
   */
  notificationType?: NotificationType;
  /**
   * Data
   * Extra metadata for deep-links or client handling
   */
  data?:
    | (
        | NotificationActionVisitMetadata
        | NotificationVisitAssignmentBatchMetadata
        | NotificationScheduleUpdatedMetadata
        | NotificationScheduleChangeMetadata
        | NotificationActionCarergiverShiftMetadata
        | NotificationActionDataExportMetadata
        | NotificationNoteMetadata
        | NotificationDoctorInstructionMetadata
        | NotificationVisitBatchDeleteMetadata
        | NotificationVisitBillingSyncBatchMetadata
        | NotificationVisitCompleteBatchMetadata
      )[]
    | null;
}

/** NotificationSendResponse */
export interface NotificationSendResponse {
  /**
   * Sent
   * Number of successfully sent push messages
   */
  sent: number;
  /**
   * Responses
   * FCM message IDs
   */
  responses?: string[];
}

/** NotificationToken */
export interface NotificationToken {
  /** Userid */
  userId: number;
  /**
   * Devicetoken
   * FCM/APNs/Web push token
   * @minLength 1
   */
  deviceToken: string;
  /**
   * Platform
   * Platform type: ios, android, or web
   */
  platform?: 'ios' | 'android' | 'web' | null;
  /**
   * Deviceinfo
   * Optional device info, e.g., "iPhone 14, iOS 17.3"
   */
  deviceInfo?: string | null;
  /**
   * Isactive
   * @default true
   */
  isActive?: boolean;
  /** Lastusedat */
  lastUsedAt?: string | null;
  /** Notificationtokenid */
  notificationTokenId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
}

/**
 * NotificationTokenCreate
 * Schema for creating a notification token. user_id is extracted from JWT, not from request.
 */
export interface NotificationTokenCreate {
  /**
   * Devicetoken
   * FCM/APNs/Web push token
   * @minLength 1
   */
  deviceToken: string;
  /**
   * Platform
   * Platform type: ios, android, or web
   */
  platform?: 'ios' | 'android' | 'web' | null;
  /**
   * Deviceinfo
   * Optional device info, e.g., "iPhone 14, iOS 17.3"
   */
  deviceInfo?: string | null;
  /**
   * Isactive
   * @default true
   */
  isActive?: boolean;
  /** Lastusedat */
  lastUsedAt?: string | null;
}

/** NotificationUpdate */
export interface NotificationUpdate {
  /** Isread */
  isRead?: boolean | null;
  /** Readat */
  readAt?: string | null;
  /**
   * Metadata
   * Metadata for push notifications
   */
  metadata?:
    | (
        | NotificationActionVisitMetadata
        | NotificationVisitAssignmentBatchMetadata
        | NotificationScheduleUpdatedMetadata
        | NotificationScheduleChangeMetadata
        | NotificationActionCarergiverShiftMetadata
        | NotificationActionDataExportMetadata
        | NotificationNoteMetadata
        | NotificationDoctorInstructionMetadata
        | NotificationVisitBatchDeleteMetadata
        | NotificationVisitBillingSyncBatchMetadata
        | NotificationVisitCompleteBatchMetadata
      )[]
    | null;
  /** Actionat */
  actionAt?: string | null;
  /** Actionvalue */
  actionValue?: 'accept' | 'reject' | null;
}

/**
 * NotificationVisitAssignmentBatchMetadata
 * One assignment covering MANY visits at once.
 *
 * A staffed line on a service request expands to every visit its recurrence
 * calls for - a three-month programme is ~60 of them. Sending
 * ``visit_assignment_added`` per visit would be ~60 pushes for a single act of
 * staffing, so a caregiver who gained more than one visit from the same line
 * gets this instead: one notification carrying the count and the span.
 *
 * ``batch_kind`` is what the summary is a summary OF, and it drives which
 * template renders (package / recurring / a plain multi-visit line), so the
 * message can say "the package X" rather than a generic count.
 *
 * Not a subset of :class:`NotificationActionVisitMetadata`: that one is about
 * ONE visit and its ``visit_id`` is what the mobile deep-link opens. A batch has
 * no single visit to open, so it carries ``visit_ids`` (plural) and deliberately
 * NO ``visit_id`` - which is also what keeps the two apart in
 * :func:`_metadata_discriminator`.
 */
export interface NotificationVisitAssignmentBatchMetadata {
  /** Servicerequestid */
  serviceRequestId: number;
  /** Lineid */
  lineId?: number | null;
  /** Linename */
  lineName?: string | null;
  /** Batchkind */
  batchKind: 'package' | 'recurring' | 'multiple';
  /** Visitcount */
  visitCount: number;
  /** Visitids */
  visitIds: number[];
  /** Firstvisitstarttime */
  firstVisitStartTime: string;
  /** Lastvisitstarttime */
  lastVisitStartTime: string;
  /** Clientid */
  clientId: number;
  /** Clientfirstname */
  clientFirstName: string;
  /** Clientlastname */
  clientLastName: string;
  /** Caregiverids */
  caregiverIds: number[];
  /** Caregivernames */
  caregiverNames: string[];
}

/** NotificationVisitBatchDeleteItemResult */
export interface NotificationVisitBatchDeleteItemResult {
  /** Visitid */
  visitId: number;
  /** Status */
  status: 'deleted' | 'not_found';
  /** Detail */
  detail?: string | null;
}

/** NotificationVisitBatchDeleteMetadata */
export interface NotificationVisitBatchDeleteMetadata {
  /** Requestedcount */
  requestedCount: number;
  /** Deletedcount */
  deletedCount: number;
  /** Notfoundcount */
  notFoundCount: number;
  /** Results */
  results: NotificationVisitBatchDeleteItemResult[];
}

/** NotificationVisitBillingSyncBatchMetadata */
export interface NotificationVisitBillingSyncBatchMetadata {
  /** Requestedcount */
  requestedCount: number;
  /** Syncedcount */
  syncedCount: number;
  /** Skippedcount */
  skippedCount: number;
  /** Notfoundcount */
  notFoundCount: number;
  /** Failedcount */
  failedCount: number;
  /** Results */
  results: NotificationVisitBillingSyncItemResult[];
}

/** NotificationVisitBillingSyncItemResult */
export interface NotificationVisitBillingSyncItemResult {
  /** Visitid */
  visitId: number;
  /** Status */
  status: 'synced' | 'skipped' | 'not_found' | 'failed';
  /** Visitstatus */
  visitStatus?: string | null;
  /** Detail */
  detail?: string | null;
}

/** NotificationVisitCompleteBatchMetadata */
export interface NotificationVisitCompleteBatchMetadata {
  /** Requestedcount */
  requestedCount: number;
  /** Completedcount */
  completedCount: number;
  /** Skippedcount */
  skippedCount: number;
  /** Failedcount */
  failedCount: number;
  /** Notfoundcount */
  notFoundCount: number;
  /** Results */
  results: NotificationVisitCompleteItemResult[];
}

/** NotificationVisitCompleteItemResult */
export interface NotificationVisitCompleteItemResult {
  /** Visitid */
  visitId: number;
  /** Status */
  status: 'completed' | 'skipped' | 'failed' | 'not_found';
  /** Visitstatus */
  visitStatus?: string | null;
  /** Detail */
  detail?: string | null;
}

/** NotificationVisitMinifiedMetadata */
export interface NotificationVisitMinifiedMetadata {
  /** Caregivernames */
  caregiverNames: string[];
  /** Visitid */
  visitId: number;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/notifications-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title notifications
 * @version 1.0.0
 * @baseUrl /api/v1/notifications-api/
 *
 *
 * Microservice for managing home care notifications.
 *
 * ## Features
 * * Register tokens for users and send notifications
 * * Manage services and attachments
 * * Register device tokens and send push notifications
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * @description Returns the health status and version of the service
     *
     * @tags Health
     * @name GetNotificationServiceHealth
     * @summary Health check endpoint
     * @request GET:/health
     * @secure
     */
    getNotificationServiceHealth: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  notifications = {
    /**
     * @description This endpoint allows a user to register a new notification token. The user_id is automatically extracted from the JWT token.
     *
     * @tags NotificationToken
     * @name RegisterNotificationToken
     * @summary Register a new notification token
     * @request POST:/notifications/token/register
     * @secure
     */
    registerNotificationToken: (data: NotificationTokenCreate, params: RequestParams = {}) =>
      this.request<NotificationToken, void | HTTPValidationError>({
        path: `/notifications/token/register`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description This endpoint retrieves a notification token by its ID.
     *
     * @tags NotificationToken
     * @name GetNotificationTokenById
     * @summary Get a notification token by its ID
     * @request GET:/notifications/token/{token_id}
     * @secure
     */
    getNotificationTokenById: (tokenId: number, params: RequestParams = {}) =>
      this.request<NotificationToken, void | HTTPValidationError>({
        path: `/notifications/token/${tokenId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description This endpoint retrieves all notification tokens for a specific user.
     *
     * @tags NotificationToken
     * @name ListNotificationTokensByUser
     * @summary Get all notification tokens for a user
     * @request GET:/notifications/token/user/{user_id}
     * @secure
     */
    listNotificationTokensByUser: (userId: number, params: RequestParams = {}) =>
      this.request<NotificationToken[], HTTPValidationError | void>({
        path: `/notifications/token/user/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sends a push notification to a specific user and logs it to the DB.
     *
     * @tags Notifications
     * @name SendNotificationToUser
     * @summary Send a notification to a user
     * @request POST:/notifications/send/{user_id}
     * @secure
     */
    sendNotificationToUser: (userId: number, data: NotificationSendRequest, params: RequestParams = {}) =>
      this.request<NotificationSendResponse, void | HTTPValidationError>({
        path: `/notifications/send/${userId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Single endpoint to list/search notifications with pagination and filters. Searches `title`/`message` with `q`, and filters by `userId`, `isRead`, `visitId`, `notification_types`, and `action_values` (any of: accept, reject, null).
     *
     * @tags Notifications
     * @name ListNotifications
     * @summary List notifications paginated with search and filters
     * @request GET:/notifications
     * @secure
     */
    listNotifications: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @default 100
         */
        limit?: number;
        /**
         * Q
         * Free-text search on title/message
         */
        q?: string | null;
        /**
         * User Id
         * Filter by user id
         */
        user_id?: number | null;
        /**
         * Is Read
         * Filter by read status
         */
        is_read?: boolean | null;
        /**
         * Visit Ids
         * Filter by multiple visit ids
         */
        visit_ids?: number[] | null;
        /**
         * Notification Types
         * Filter by one or more notification types. Repeat the param for multiple.
         */
        notification_types?: NotificationType[] | null;
        /**
         * Action Values
         * Filter by one or more action values. Repeat the param for multiple.
         */
        action_values?: ('accept' | 'reject' | 'null')[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationGetAllPaginationResponse, void | HTTPValidationError>({
        path: `/notifications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Single endpoint to list/search notifications with pagination and filters. Searches `title`/`message` with `q`, and filters by `userId`, `isRead`, `visitId`, `notification_types`, and `action_values` (any of: accept, reject, null).
     *
     * @tags Notifications
     * @name ListNotificationsMinified
     * @summary List notifications paginated with search and filters with minified schema
     * @request GET:/notifications/minified
     * @secure
     */
    listNotificationsMinified: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @default 100
         */
        limit?: number;
        /**
         * Q
         * Free-text search on title/message
         */
        q?: string | null;
        /**
         * User Id
         * Filter by user id
         */
        user_id?: number | null;
        /**
         * Is Read
         * Filter by read status
         */
        is_read?: boolean | null;
        /**
         * Visit Ids
         * Filter by multiple visit ids
         */
        visit_ids?: number[] | null;
        /**
         * Notification Types
         * Filter by one or more notification types. Repeat the param for multiple.
         */
        notification_types?: NotificationType[] | null;
        /**
         * Action Values
         * Filter by one or more action values. Repeat the param for multiple.
         */
        action_values?: ('accept' | 'reject' | 'null')[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationGetAllMinifiedPaginationResponse, void | HTTPValidationError>({
        path: `/notifications/minified`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description This endpoint retrieves a specific notification by its ID.
     *
     * @tags Notifications
     * @name GetNotificationById
     * @summary Get a notification by ID
     * @request GET:/notifications/item/{notification_id}
     * @secure
     */
    getNotificationById: (notificationId: number, params: RequestParams = {}) =>
      this.request<Notification, void | HTTPValidationError>({
        path: `/notifications/item/${notificationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a notification
     *
     * @tags Notifications
     * @name UpdateNotification
     * @summary Updates a notification
     * @request PUT:/notifications/item/{notification_id}
     * @secure
     */
    updateNotification: (notificationId: number, data: NotificationUpdate, params: RequestParams = {}) =>
      this.request<Notification, void | HTTPValidationError>({
        path: `/notifications/item/${notificationId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a notification
     *
     * @tags Notifications
     * @name DeleteNotification
     * @summary Deletes a notification
     * @request DELETE:/notifications/item/{notification_id}
     * @secure
     */
    deleteNotification: (notificationId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/notifications/item/${notificationId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Updates all unread notifications for a user and marks them as read.
     *
     * @tags Notifications
     * @name MarkAllNotificationsRead
     * @summary Mark all notifications as read for a user
     * @request POST:/notifications/user/{user_id}/mark-all-read
     * @secure
     */
    markAllNotificationsRead: (userId: number, params: RequestParams = {}) =>
      this.request<Record<string, any>, void | HTTPValidationError>({
        path: `/notifications/user/${userId}/mark-all-read`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Marks the specified notification IDs as read for the given user.
     *
     * @tags Notifications
     * @name MarkSelectedNotificationsRead
     * @summary Mark selected notifications as read
     * @request POST:/notifications/user/{user_id}/mark-read
     * @secure
     */
    markSelectedNotificationsRead: (userId: number, data: MarkSelectedReadRequest, params: RequestParams = {}) =>
      this.request<MarkSelectedReadResponse, void | HTTPValidationError>({
        path: `/notifications/user/${userId}/mark-read`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates the notification's `action_value` and `action_at`. If the value is **reject**, unassigns caregivers from the given visit and sends a broadcast notification to all administrators.
     *
     * @tags Notifications
     * @name ActOnNotification
     * @summary Record action on a notification (accept/reject) and send notification to admins
     * @request POST:/notifications/{notification_id}/action
     * @secure
     */
    actOnNotification: (notificationId: number, data: NotificationActionRequest, params: RequestParams = {}) =>
      this.request<NotificationActionResponse, HTTPValidationError>({
        path: `/notifications/${notificationId}/action`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
